import React from 'react'

function EyeIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke="#56565A"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M2.97 12.737a2.265 2.265 0 0 1 0-1.472C4.264 7.503 7.819 4.8 12 4.8c4.183 0 7.737 2.702 9.03 6.464.164.477.164.995 0 1.472C19.737 16.499 16.183 19.2 12 19.2c-4.182 0-7.737-2.702-9.03-6.464Z"
      />
      <circle
        cx={12}
        cy={12}
        r={2.5}
        stroke="#56565A"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  )
}
export default EyeIcon
